export default __webpack_public_path__ + "static/favicon-22d378f70af64302d3b3812009c4f53e.png";